import React, { Component } from 'react'
import MasterTemplatePageSF from '../MasterTemplatePageSF.js'

class MasterPersonalGuaranteePageSF extends Component {
  render() {
    return (
      <MasterTemplatePageSF
        {...this.props}
        templateCode='personal_guarantee_general'
        title='Personal Guarantee'
        activeTab='personalGuarantee'
        navConfig={null}
      />
    )
  }
}

export default MasterPersonalGuaranteePageSF
